<template>
  <md-card
    v-if="
      $store.state.electionEvent &&
        $store.state.electionEvent.ElectionEvent.Description
    "
  >
    <md-card-content class="label">
      <!--       {{
        $store.state.electionEvent.ElectionEvent.Description.Message[0]
          .content[0]
      }} -->
      {{ getMessages("DISCLAIMER") }}
      <div v-if="accepted">
        {{ $t("disclaimer.accepted") }}
      </div>
    </md-card-content>

    <md-dialog
      role="dialog"
      :aria-modal="alert"
      id="alert-message-dialog"
      :md-fullscreen="false"
      :md-active.sync="alert"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
      @keydown.tab="
        utils.handleTabNavigation(
          $event,
          null,
          null,
          '#alert-message-dialog',
          null
        )
      "
      @md-opened="
        hidediv = true;
        $root.$emit('lock');
        !isMobile ? utils.modalOpened('#alert-message-dialog') : '';
      "
      @md-closed="
        !isMobile ? utils.removeModalHandler() : '';
        hidediv = false;
        $root.$emit('unlock');
      "
    >
      <!--       <md-dialog-title
        class="title"
        role="heading"
        aria-level="1"
        >{{
      }}</md-dialog-title> -->
      <md-dialog-content>
        <div class="space">{{ getMessages("ALERT") }}</div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          @click="
            alert = false;
            clickAlert = true;
          "
          class="close-button"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 20"
            >{{ $t("candidate.info-dialog.close-button") }}</md-tooltip
          >
          {{ $t("candidate.info-dialog.close-button") }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
  },
  data: function() {
    return {
      accepted: false,
      alert: false,
      clickAlert: false,
      hidediv: false,
      alertMessage: "",
      isMobile: false
    };
  },
  props: [],
  methods: {
    acceptDisclaimer(value) {
      // console.log("disclaimer toggled: %s", value);
      this.accepted = value;
      this.$emit(value == true ? "disclaimerOk" : "disclaimerKo");
    },
    getMessages(type) {
      let res = "";
      let messages = this.$store.state.electionEvent.ElectionEvent.Description
        .Message;
      if (messages) {
        let messagesWithType = messages.filter(x => x.Type == type);
        messagesWithType.filter(x => (res = x.content[0]));
      }

      if (type == "ALERT" && res && !this.clickAlert) {
        this.alertMessage = res;
        this.alert = true;
      }
      return res;
    }
  }
};
</script>
<style scoped>
.label {
  text-align: justify;
  margin: 0px;
  padding: 5px;
}

.dialog {
  overflow: auto;
}

span.md-dialog-title {
  text-align: center !important;
}

.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: #fff;
  padding: 5px;
}

.md-subtitle {
  padding: 15px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
}

.md-button.md-theme-default[disabled].md-primary .md-icon-font {
  color: rgba(0, 0, 0, 0.8) !important;
}

.md-dialog-actions {
  margin-bottom: 10px;
}
.space {
  color: #000 !important;
  font-size: 14px;
  margin: 10px;
}

.close-button {
  border-radius: var(--brb);
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
}
</style>
